const RESPONSE = {
	RESPONSE_SUCCESS: 'response-success',
	RESPONSE_FAIL: 'response-fail',
}

const ROLE = {
	Admin: 'admin-role',
	User: 'user-role',
	NO_ONE: 'no-one',
}

const REQUEST_METHOD = {
	POST: 'post-method',
	GET: 'get-method',
	PUT: 'put-method',
	PATCH: 'patch-method',
	DELETE: 'delete-method',
}

export { RESPONSE, ROLE, REQUEST_METHOD }
